/**
 * Transform a class name in CamelCase into separate words in title case. For
 * example, AdjustableShelfProperties becomes Adjustable Shelf Properties.
 */
export const camel2words = (str: string) => {
    if (!str || str.length < 1) return '';
    let result = str[0];
    for (let i = 1; i < str.length; i++) {
        if (/[A-Z]/.test(str[i])) {
            result += ' ' + str[i];
        } else {
            result += str[i];
        }
    }
    return result;
};

/**
 * Split kebab-case identifiers into individual words
 */
export const kebab2words = (str: string) => {
    if (!str || str.length < 1) return '';
    const words = str
        .split('-')
        .filter(w => w.length > 0);
    return words.join(' ');
}

/**
 * Puts kebab-case identifiers into naive Title Case with spaces separating
 * words. If you want AP, Chicago Manual of Style, or MLA rules, you probably
 * don't want this.
 */
export const kebab2title = (str: string) => {
    if (!str || str.length < 1) return '';
    const words = str
        .split('-')
        .filter(w => w.length > 0)
        .map(w => w[0].toUpperCase() + w.slice(1));

    return words.join(' ');
}

export const words2kebab = (str: string) => {
    return str.toLowerCase().replace(/\s+/, '-');
}

/**
 * Transform a class name in CamelCase into kebab-case. For example,
 * AdjustableShelfProperties becomes adjustable-shelf-properties.
 */
export const camel2kebab = (str: string) => {
    if (!str || str.length < 1) return '';
    let result = str[0].toLowerCase();
    for (let i = 1; i < str.length; i++) {
        if (/[A-Z]/.test(str[i])) {
            result += '-' + str[i].toLowerCase();
        } else {
            result += str[i];
        }
    }
    return result;
};

/**
 * Transform a string in camelCase into snake_case. For example,
 * AdjustableShelfProperties becomes adjustable_shelf_properties.
 */
export const camel2snake = (str: string): string => {
    if (!str || str.length < 1) return '';
    let result = str[0].toLowerCase();
    for (let i = 1; i < str.length; i++) {
        if (/[A-Z]/.test(str[i])) {
            result += '_' + str[i].toLowerCase();
        } else {
            result += str[i];
        }
    }
    return result;
};

/**
 * Capitalize the first letter of a string. This is a no-op if the leading
 * character has no capitialized equivalent.
 */
export const capitalize = (str: string) => {
    if (!str || str.length < 1) return '';
    if (typeof str != 'string') str = String(str);
    return str[0].toUpperCase() + str.slice(1);
};

